import React, { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";

import TopBar from "./TopBar";

import coin from "../../assets/coin.png";
import community from "../../assets/community.png";
import buy from "../../assets/buy.png";
import privacy from "../../assets/privacy.png";
import terms from "../../assets/terms.png";
import profile from "../../assets/profile_edit.png";

function UserProfile() {
  const navigate = useNavigate();

  const user_data = JSON.parse(sessionStorage.getItem("userdata"));
  useEffect(() => {
    if (!user_data) navigate("/user/login");
  });

  return (
    <div className="bg flex flex-col bg h-full min-h-screen">
      <TopBar />
      <div className="flex items-center justify-center font-semibold">
        <div className="flex flex-col items-center m-5 w-3/5">
          <div className="flex justify-between items-center text-xl w-full border-b-2 p-4 pt-0 border-gray-700">
            <div className="flex gap-3 items-center text-slate-100">
              <img
                src={"" + user_data.image}
                alt="user"
                className="rounded-full w-16"
              />
              <div className="flex align-center justify-center">
                <div className="text-[#000] text-xl">{user_data.email}</div>
              </div>
            </div>
            <div className="flex items-center gap-2 text-yellow-700">
              <img src={coin} alt="coins" />
              {user_data.total_coins}
            </div>
          </div>
          <div className="grid grid-cols-2 gap-5 p-5 w-full text-slate-100">
            <div
              className="h-20 flex gap-3 bg-opacity-10 bg-black w-full items-center justify-center rounded-lg shadow cursor-pointer"
              onClick={() => navigate("/terms")}
            >
              <img src={terms} alt="terms" />
              <div className="flex align-center justify-center">
                <div className="text-[#000]">Terms & Conditions</div>
              </div>
            </div>
            <div
              className="h-20 flex gap-3 bg-opacity-10 bg-black w-full items-center justify-center rounded-lg shadow cursor-pointer"
              onClick={() => navigate("/terms")}
            >
              <img src={privacy} alt="privacy" />
              <div className="flex align-center justify-center">
                <div className="text-[#000]">Privacy</div>
              </div>
            </div>
            <div
              className="h-20 flex gap-3 bg-opacity-10 bg-black w-full items-center justify-center rounded-lg shadow cursor-pointer"
              onClick={() => navigate("/terms")}
            >
              <img src={community} alt="community" />
              <div className="flex align-center justify-center">
                <div className="text-[#000]">Community Guidelines</div>
              </div>
            </div>
            <div
              className="h-20 flex gap-3 bg-opacity-10 bg-black w-full items-center justify-center rounded-lg shadow cursor-pointer"
              onClick={() => navigate("/user/updateprofile")}
            >
              <img src={profile} alt="community" />
              <div className="flex align-center justify-center">
                <div className="text-[#000]">Update Profile</div>
              </div>
            </div>
            <div
              className="h-20 flex gap-3 bg-opacity-10 bg-black w-full items-center justify-center rounded-lg shadow"
              onClick={() => navigate("/user/purchase-token")}
            >
              <img src={buy} alt="buy" />
              <div className="flex align-center justify-center">
                <div className="text-[#000]">Buy Token</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserProfile;
